"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function JetSectionBorder() {
    return (react_1.default.createElement("div", { className: "hidden sm:block" },
        react_1.default.createElement("div", { className: "py-8" },
            react_1.default.createElement("div", { className: "border-t border-gray-200" }))));
}
exports.default = JetSectionBorder;
